import { authenticatedFetch } from './api'; // <-- FIX: Use named import

const feedbackService = {
  /**
   * Gets all feedback for a specific work order.
   * @param {string} workOrderId - The ID of the work order.
   * @returns {Promise<Array>} A list of feedback entries.
   */
  getFeedbackForWorkOrder: async (workOrderId) => {
    try {
      // FIX: Use authenticatedFetch with the correct syntax
      const data = await authenticatedFetch(`/feedback/${workOrderId}`);
      return data;
    } catch (error) {
      console.error('Error fetching feedback for work order:', error);
      throw error;
    }
  },

  /**
   * Submits new feedback from an admin.
   * @param {object} feedbackData - The feedback data.
   * @returns {Promise<object>} The submitted feedback.
   */
  submitAdminFeedback: async (feedbackData) => {
    try {
      // Ensure the source is set correctly for admin feedback
      const payload = { ...feedbackData, source: 'admin' };
      
      // FIX: Use authenticatedFetch with POST method and a JSON body
      const data = await authenticatedFetch('/feedback', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      return data;
    } catch (error) {
      console.error('Error submitting admin feedback:', error);
      throw error;
    }
  },
};

export default feedbackService;